import React from 'react';
import { BADGE_COLOR_SCHEMES } from './consts';

interface IProps {
  colorSchemeId: string;
  title: string;
}
const TitleBadge = ({ title, colorSchemeId }: IProps) => <div className={`${BADGE_COLOR_SCHEMES[colorSchemeId as keyof typeof BADGE_COLOR_SCHEMES]} px-[8px] py-[2px] font-metricR text-[12px] border-[1px] rounded-[3px]`}>{title}</div>;

export default TitleBadge;
